import React, { useEffect } from 'react';
import { STATIC_IMAGES } from '../../javascript/services/globalVars';

function RemoteImage(Props) {
   const root = import.meta.env.VITE_MEDIA_HOST;
   useEffect(() => {}, [Props.src]);
   const src = Props.src && (Props.src.startsWith('http://') || Props.src.startsWith('https://')) ? Props.src : root + Props.src;
   return (<img className={Props.className} src={src} alt={Props.alt} onError={({ currentTarget }) => { currentTarget.onerror = null; currentTarget.src=root+STATIC_IMAGES.SMEGold; }}/>);
}

export default RemoteImage;